var items = {
  "block.minecraft.air": "空氣",
  "block.minecraft.stone": "石頭",
  "block.minecraft.granite": "花崗岩",
  "block.minecraft.polished_granite": "拋光花崗岩",
  "block.minecraft.diorite": "閃長岩",
  "block.minecraft.polished_diorite": "拋光閃長岩",
  "block.minecraft.andesite": "安山岩",
  "block.minecraft.polished_andesite": "拋光安山岩",
  "block.minecraft.grass_block": "草地",
  "block.minecraft.dirt": "泥土",
  "block.minecraft.coarse_dirt": "粗泥",
  "block.minecraft.podzol": "灰壤",
  "block.minecraft.crimson_nylium": "猩紅菌絲石",
  "block.minecraft.warped_nylium": "迷離菌絲石",
  "block.minecraft.cobblestone": "碎石",
  "block.minecraft.oak_planks": "橡木板",
  "block.minecraft.spruce_planks": "杉木板",
  "block.minecraft.birch_planks": "樺木板",
  "block.minecraft.jungle_planks": "叢林木板",
  "block.minecraft.acacia_planks": "相思木板",
  "block.minecraft.dark_oak_planks": "黑橡木板",
  "block.minecraft.crimson_planks": "猩紅菌木板",
  "block.minecraft.warped_planks": "迷離菌木板",
  "block.minecraft.oak_sapling": "橡木樹苗",
  "block.minecraft.spruce_sapling": "杉木樹苗",
  "block.minecraft.birch_sapling": "樺木樹苗",
  "block.minecraft.jungle_sapling": "叢林木樹苗",
  "block.minecraft.acacia_sapling": "相思木樹苗",
  "block.minecraft.dark_oak_sapling": "黑橡木樹苗",
  "block.minecraft.bedrock": "基岩",
  "block.minecraft.sand": "沙",
  "block.minecraft.red_sand": "紅沙",
  "block.minecraft.gravel": "砂礫",
  "block.minecraft.gold_ore": "金礦",
  "block.minecraft.iron_ore": "鐵礦",
  "block.minecraft.coal_ore": "煤礦",
  "block.minecraft.nether_gold_ore": "地獄金礦",
  "block.minecraft.oak_log": "橡木原木",
  "block.minecraft.spruce_log": "杉木原木",
  "block.minecraft.birch_log": "樺木原木",
  "block.minecraft.jungle_log": "叢林木原木",
  "block.minecraft.acacia_log": "相思木原木",
  "block.minecraft.dark_oak_log": "黑橡木原木",
  "block.minecraft.crimson_stem": "猩紅菌椗",
  "block.minecraft.warped_stem": "迷離菌椗",
  "block.minecraft.stripped_oak_log": "剝皮橡木原木",
  "block.minecraft.stripped_spruce_log": "剝皮杉木原木",
  "block.minecraft.stripped_birch_log": "剝皮樺木原木",
  "block.minecraft.stripped_jungle_log": "剝皮叢林木原木",
  "block.minecraft.stripped_acacia_log": "剝皮相思木原木",
  "block.minecraft.stripped_dark_oak_log": "剝皮黑橡木原木",
  "block.minecraft.stripped_crimson_stem": "剝皮猩紅菌椗",
  "block.minecraft.stripped_warped_stem": "剝皮迷離菌椗",
  "block.minecraft.stripped_oak_wood": "剝皮橡木",
  "block.minecraft.stripped_spruce_wood": "剝皮杉木",
  "block.minecraft.stripped_birch_wood": "剝皮樺木",
  "block.minecraft.stripped_jungle_wood": "剝皮叢林木",
  "block.minecraft.stripped_acacia_wood": "剝皮相思木",
  "block.minecraft.stripped_dark_oak_wood": "剝皮黑橡木",
  "block.minecraft.stripped_crimson_hyphae": "剝皮猩紅菌絲體",
  "block.minecraft.stripped_warped_hyphae": "剝皮迷離菌絲體",
  "block.minecraft.oak_wood": "橡木",
  "block.minecraft.spruce_wood": "杉木",
  "block.minecraft.birch_wood": "樺木",
  "block.minecraft.jungle_wood": "叢林木",
  "block.minecraft.acacia_wood": "相思木",
  "block.minecraft.dark_oak_wood": "黑橡木",
  "block.minecraft.crimson_hyphae": "猩紅菌絲體",
  "block.minecraft.warped_hyphae": "迷離菌絲體",
  "block.minecraft.oak_leaves": "橡木樹葉",
  "block.minecraft.spruce_leaves": "杉木樹葉",
  "block.minecraft.birch_leaves": "樺木樹葉",
  "block.minecraft.jungle_leaves": "叢林木樹葉",
  "block.minecraft.acacia_leaves": "相思木樹葉",
  "block.minecraft.dark_oak_leaves": "黑橡木樹葉",
  "block.minecraft.sponge": "海綿",
  "block.minecraft.wet_sponge": "濕海綿",
  "block.minecraft.glass": "玻璃",
  "block.minecraft.lapis_ore": "青金石礦",
  "block.minecraft.lapis_block": "青金石磚",
  "block.minecraft.dispenser": "發射器",
  "block.minecraft.sandstone": "砂岩",
  "block.minecraft.chiseled_sandstone": "浮雕砂岩",
  "block.minecraft.cut_sandstone": "切製砂岩",
  "block.minecraft.note_block": "音符盒",
  "block.minecraft.powered_rail": "動力路軌",
  "block.minecraft.detector_rail": "感壓路軌",
  "block.minecraft.sticky_piston": "黏性活塞",
  "block.minecraft.cobweb": "蜘蛛網",
  "block.minecraft.grass": "草",
  "block.minecraft.fern": "蕨",
  "block.minecraft.dead_bush": "死灌木",
  "block.minecraft.seagrass": "海草",
  "block.minecraft.sea_pickle": "海鞘",
  "block.minecraft.piston": "活塞",
  "block.minecraft.white_wool": "白色羊毛",
  "block.minecraft.orange_wool": "橙色羊毛",
  "block.minecraft.magenta_wool": "紫紅色羊毛",
  "block.minecraft.light_blue_wool": "淺藍色羊毛",
  "block.minecraft.yellow_wool": "黃色羊毛",
  "block.minecraft.lime_wool": "淺綠色羊毛",
  "block.minecraft.pink_wool": "粉紅色羊毛",
  "block.minecraft.gray_wool": "灰色羊毛",
  "block.minecraft.light_gray_wool": "淺灰色羊毛",
  "block.minecraft.cyan_wool": "青藍色羊毛",
  "block.minecraft.purple_wool": "紫色羊毛",
  "block.minecraft.blue_wool": "藍色羊毛",
  "block.minecraft.brown_wool": "啡色羊毛",
  "block.minecraft.green_wool": "綠色羊毛",
  "block.minecraft.red_wool": "紅色羊毛",
  "block.minecraft.black_wool": "黑色羊毛",
  "block.minecraft.dandelion": "蒲公英",
  "block.minecraft.poppy": "罌粟",
  "block.minecraft.blue_orchid": "蘭花",
  "block.minecraft.allium": "絨球葱",
  "block.minecraft.azure_bluet": "雛草",
  "block.minecraft.red_tulip": "紅色鬱金香",
  "block.minecraft.orange_tulip": "橙色鬱金香",
  "block.minecraft.white_tulip": "白色鬱金香",
  "block.minecraft.pink_tulip": "粉紅色鬱金香",
  "block.minecraft.oxeye_daisy": "雛菊",
  "block.minecraft.cornflower": "矢車菊",
  "block.minecraft.lily_of_the_valley": "鈴蘭",
  "block.minecraft.wither_rose": "凋零玫瑰",
  "block.minecraft.brown_mushroom": "啡色蘑菇",
  "block.minecraft.red_mushroom": "紅色蘑菇",
  "block.minecraft.crimson_fungus": "猩紅菌菇",
  "block.minecraft.warped_fungus": "迷離菌菇",
  "block.minecraft.crimson_roots": "猩紅菌根",
  "block.minecraft.warped_roots": "迷離菌根",
  "block.minecraft.nether_sprouts": "地獄芽",
  "block.minecraft.weeping_vines": "哭泣藤",
  "block.minecraft.twisting_vines": "扭曲藤",
  "block.minecraft.sugar_cane": "蔗",
  "block.minecraft.kelp": "海帶",
  "block.minecraft.bamboo": "竹",
  "block.minecraft.gold_block": "金磚",
  "block.minecraft.iron_block": "鐵磚",
  "block.minecraft.oak_slab": "橡木半磚",
  "block.minecraft.spruce_slab": "杉木半磚",
  "block.minecraft.birch_slab": "樺木半磚",
  "block.minecraft.jungle_slab": "叢林木半磚",
  "block.minecraft.acacia_slab": "相思木半磚",
  "block.minecraft.dark_oak_slab": "黑橡木半磚",
  "block.minecraft.crimson_slab": "猩紅菌木半磚",
  "block.minecraft.warped_slab": "迷離菌木半磚",
  "block.minecraft.stone_slab": "石頭半磚",
  "block.minecraft.smooth_stone_slab": "平滑石頭半磚",
  "block.minecraft.sandstone_slab": "砂岩半磚",
  "block.minecraft.cut_sandstone_slab": "切製砂岩半磚",
  "block.minecraft.petrified_oak_slab": "石化橡木半磚",
  "block.minecraft.cobblestone_slab": "碎石半磚",
  "block.minecraft.brick_slab": "紅磚半磚",
  "block.minecraft.stone_brick_slab": "石磚半磚",
  "block.minecraft.nether_brick_slab": "地獄磚半磚",
  "block.minecraft.quartz_slab": "石英半磚",
  "block.minecraft.red_sandstone_slab": "紅砂岩半磚",
  "block.minecraft.cut_red_sandstone_slab": "切製紅砂岩半磚",
  "block.minecraft.purpur_slab": "紫珀半磚",
  "block.minecraft.prismarine_slab": "海磷石半磚",
  "block.minecraft.prismarine_brick_slab": "海磷石磚半磚",
  "block.minecraft.dark_prismarine_slab": "暗海磷石半磚",
  "block.minecraft.smooth_quartz": "平滑石英磚",
  "block.minecraft.smooth_red_sandstone": "平滑紅砂岩",
  "block.minecraft.smooth_sandstone": "平滑砂岩",
  "block.minecraft.smooth_stone": "平滑石頭",
  "block.minecraft.bricks": "紅磚",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "書櫃",
  "block.minecraft.mossy_cobblestone": "青苔碎石",
  "block.minecraft.obsidian": "黑曜石",
  "block.minecraft.torch": "火炬",
  "block.minecraft.end_rod": "終界燭",
  "block.minecraft.chorus_plant": "歌萊枝",
  "block.minecraft.chorus_flower": "歌萊花",
  "block.minecraft.purpur_block": "紫珀磚",
  "block.minecraft.purpur_pillar": "紫珀柱",
  "block.minecraft.purpur_stairs": "紫珀樓梯",
  "block.minecraft.spawner": "生成籠",
  "block.minecraft.oak_stairs": "橡木樓梯",
  "block.minecraft.chest": "儲物箱",
  "block.minecraft.diamond_ore": "鑽石礦",
  "block.minecraft.diamond_block": "鑽石磚",
  "block.minecraft.crafting_table": "工作台",
  "block.minecraft.farmland": "耕地",
  "block.minecraft.furnace": "熔爐",
  "block.minecraft.ladder": "梯",
  "block.minecraft.rail": "路軌",
  "block.minecraft.cobblestone_stairs": "碎石樓梯",
  "block.minecraft.lever": "拉桿",
  "block.minecraft.stone_pressure_plate": "石製壓力板",
  "block.minecraft.oak_pressure_plate": "橡木壓力板",
  "block.minecraft.spruce_pressure_plate": "杉木壓力板",
  "block.minecraft.birch_pressure_plate": "樺木壓力板",
  "block.minecraft.jungle_pressure_plate": "叢林木壓力板",
  "block.minecraft.acacia_pressure_plate": "相思木壓力板",
  "block.minecraft.dark_oak_pressure_plate": "黑橡木壓力板",
  "block.minecraft.crimson_pressure_plate": "猩紅菌木壓力板",
  "block.minecraft.warped_pressure_plate": "迷離菌木壓力板",
  "block.minecraft.polished_blackstone_pressure_plate": "拋光黑石壓力板",
  "block.minecraft.redstone_ore": "紅石礦",
  "block.minecraft.redstone_torch": "紅石火炬",
  "block.minecraft.snow": "積雪",
  "block.minecraft.ice": "冰",
  "block.minecraft.snow_block": "雪",
  "block.minecraft.cactus": "仙人掌",
  "block.minecraft.clay": "黏土",
  "block.minecraft.jukebox": "唱片機",
  "block.minecraft.oak_fence": "橡木欄杆",
  "block.minecraft.spruce_fence": "杉木欄杆",
  "block.minecraft.birch_fence": "樺木欄杆",
  "block.minecraft.jungle_fence": "叢林木欄杆",
  "block.minecraft.acacia_fence": "相思木欄杆",
  "block.minecraft.dark_oak_fence": "黑橡木欄杆",
  "block.minecraft.crimson_fence": "猩紅菌木欄杆",
  "block.minecraft.warped_fence": "迷離菌木欄杆",
  "block.minecraft.pumpkin": "南瓜",
  "block.minecraft.carved_pumpkin": "雕刻南瓜",
  "block.minecraft.netherrack": "地獄石",
  "block.minecraft.soul_sand": "靈魂砂",
  "block.minecraft.soul_soil": "靈魂土",
  "block.minecraft.basalt": "玄武岩",
  "block.minecraft.polished_basalt": "拋光玄武岩",
  "block.minecraft.soul_torch": "靈魂火炬",
  "block.minecraft.glowstone": "熒光石",
  "block.minecraft.jack_o_lantern": "南瓜燈",
  "block.minecraft.oak_trapdoor": "橡木地板門",
  "block.minecraft.spruce_trapdoor": "杉木地板門",
  "block.minecraft.birch_trapdoor": "樺木地板門",
  "block.minecraft.jungle_trapdoor": "叢林木地板門",
  "block.minecraft.acacia_trapdoor": "相思木地板門",
  "block.minecraft.dark_oak_trapdoor": "黑橡木地板門",
  "block.minecraft.crimson_trapdoor": "猩紅菌木地板門",
  "block.minecraft.warped_trapdoor": "迷離菌木地板門",
  "block.minecraft.infested_stone": "蛀蝕嘅石頭",
  "block.minecraft.infested_cobblestone": "蛀蝕嘅碎石",
  "block.minecraft.infested_stone_bricks": "蛀蝕嘅石磚",
  "block.minecraft.infested_mossy_stone_bricks": "蛀蝕嘅青苔石磚",
  "block.minecraft.infested_cracked_stone_bricks": "蛀蝕嘅裂紋石磚",
  "block.minecraft.infested_chiseled_stone_bricks": "蛀蝕嘅浮雕石磚",
  "block.minecraft.stone_bricks": "石磚",
  "block.minecraft.mossy_stone_bricks": "青苔石磚",
  "block.minecraft.cracked_stone_bricks": "裂紋石磚",
  "block.minecraft.chiseled_stone_bricks": "浮雕石磚",
  "block.minecraft.brown_mushroom_block": "啡色蘑菇方塊",
  "block.minecraft.red_mushroom_block": "紅色蘑菇方塊",
  "block.minecraft.mushroom_stem": "蘑菇椗",
  "block.minecraft.iron_bars": "鐵欄杆",
  "block.minecraft.chain": "鐵鏈",
  "block.minecraft.glass_pane": "玻璃片",
  "block.minecraft.melon": "西瓜",
  "block.minecraft.vine": "藤蔓",
  "block.minecraft.oak_fence_gate": "橡木閘門",
  "block.minecraft.spruce_fence_gate": "杉木閘門",
  "block.minecraft.birch_fence_gate": "樺木閘門",
  "block.minecraft.jungle_fence_gate": "叢林木閘門",
  "block.minecraft.acacia_fence_gate": "相思木閘門",
  "block.minecraft.dark_oak_fence_gate": "黑橡木閘門",
  "block.minecraft.crimson_fence_gate": "猩紅菌木閘門",
  "block.minecraft.warped_fence_gate": "迷離菌木閘門",
  "block.minecraft.brick_stairs": "紅磚樓梯",
  "block.minecraft.stone_brick_stairs": "石磚樓梯",
  "block.minecraft.mycelium": "菌絲土",
  "block.minecraft.lily_pad": "荷葉",
  "block.minecraft.nether_bricks": "地獄磚",
  "block.minecraft.cracked_nether_bricks": "裂紋地獄磚",
  "block.minecraft.chiseled_nether_bricks": "浮雕地獄磚",
  "block.minecraft.nether_brick_fence": "地獄磚欄杆",
  "block.minecraft.nether_brick_stairs": "地獄磚樓梯",
  "block.minecraft.enchanting_table": "附魔台",
  "block.minecraft.end_portal_frame": "終界傳送門框",
  "block.minecraft.end_stone": "終界石",
  "block.minecraft.end_stone_bricks": "終界石磚",
  "block.minecraft.dragon_egg": "龍蛋",
  "block.minecraft.redstone_lamp": "紅石燈",
  "block.minecraft.sandstone_stairs": "砂岩樓梯",
  "block.minecraft.emerald_ore": "綠寶石礦",
  "block.minecraft.ender_chest": "終界箱",
  "block.minecraft.tripwire_hook": "撠線鈎",
  "block.minecraft.emerald_block": "綠寶石磚",
  "block.minecraft.spruce_stairs": "杉木樓梯",
  "block.minecraft.birch_stairs": "樺木樓梯",
  "block.minecraft.jungle_stairs": "叢林木樓梯",
  "block.minecraft.crimson_stairs": "猩紅菌木樓梯",
  "block.minecraft.warped_stairs": "迷離菌木樓梯",
  "block.minecraft.command_block": "命令方塊",
  "block.minecraft.beacon": "烽火台",
  "block.minecraft.cobblestone_wall": "碎石牆",
  "block.minecraft.mossy_cobblestone_wall": "青苔碎石牆",
  "block.minecraft.brick_wall": "紅磚牆",
  "block.minecraft.prismarine_wall": "海磷石牆",
  "block.minecraft.red_sandstone_wall": "紅砂岩牆",
  "block.minecraft.mossy_stone_brick_wall": "青苔石磚牆",
  "block.minecraft.granite_wall": "花崗岩牆",
  "block.minecraft.stone_brick_wall": "石磚牆",
  "block.minecraft.nether_brick_wall": "地獄磚牆",
  "block.minecraft.andesite_wall": "安山岩牆",
  "block.minecraft.red_nether_brick_wall": "紅色地獄磚牆",
  "block.minecraft.sandstone_wall": "砂岩牆",
  "block.minecraft.end_stone_brick_wall": "終界石磚牆",
  "block.minecraft.diorite_wall": "閃長岩牆",
  "block.minecraft.blackstone_wall": "黑石牆",
  "block.minecraft.polished_blackstone_wall": "拋光黑石牆",
  "block.minecraft.polished_blackstone_brick_wall": "拋光黑石磚牆",
  "block.minecraft.stone_button": "石製按鈕",
  "block.minecraft.oak_button": "橡木按鈕",
  "block.minecraft.spruce_button": "杉木按鈕",
  "block.minecraft.birch_button": "樺木按鈕",
  "block.minecraft.jungle_button": "叢林木按鈕",
  "block.minecraft.acacia_button": "相思木按鈕",
  "block.minecraft.dark_oak_button": "黑橡木按鈕",
  "block.minecraft.crimson_button": "猩紅菌木按鈕",
  "block.minecraft.warped_button": "迷離菌木按鈕",
  "block.minecraft.polished_blackstone_button": "拋光黑石按鈕",
  "block.minecraft.anvil": "鐵砧",
  "block.minecraft.chipped_anvil": "微損嘅鐵砧",
  "block.minecraft.damaged_anvil": "耗損嘅鐵砧",
  "block.minecraft.trapped_chest": "陷阱箱",
  "block.minecraft.light_weighted_pressure_plate": "輕質測重壓力板",
  "block.minecraft.heavy_weighted_pressure_plate": "重質測重壓力板",
  "block.minecraft.daylight_detector": "日光感測器",
  "block.minecraft.redstone_block": "紅石磚",
  "block.minecraft.nether_quartz_ore": "地獄石英礦",
  "block.minecraft.hopper": "漏斗",
  "block.minecraft.chiseled_quartz_block": "浮雕石英磚",
  "block.minecraft.quartz_block": "石英磚",
  "block.minecraft.quartz_bricks": "磚紋石英磚",
  "block.minecraft.quartz_pillar": "石英柱",
  "block.minecraft.quartz_stairs": "石英樓梯",
  "block.minecraft.activator_rail": "觸發路軌",
  "block.minecraft.dropper": "投擲器",
  "block.minecraft.white_terracotta": "白色陶瓦",
  "block.minecraft.orange_terracotta": "橙色陶瓦",
  "block.minecraft.magenta_terracotta": "紫紅色陶瓦",
  "block.minecraft.light_blue_terracotta": "淺藍色陶瓦",
  "block.minecraft.yellow_terracotta": "黃色陶瓦",
  "block.minecraft.lime_terracotta": "淺綠色陶瓦",
  "block.minecraft.pink_terracotta": "粉紅色陶瓦",
  "block.minecraft.gray_terracotta": "灰色陶瓦",
  "block.minecraft.light_gray_terracotta": "淺灰色陶瓦",
  "block.minecraft.cyan_terracotta": "青藍色陶瓦",
  "block.minecraft.purple_terracotta": "紫色陶瓦",
  "block.minecraft.blue_terracotta": "藍色陶瓦",
  "block.minecraft.brown_terracotta": "啡色陶瓦",
  "block.minecraft.green_terracotta": "綠色陶瓦",
  "block.minecraft.red_terracotta": "紅色陶瓦",
  "block.minecraft.black_terracotta": "黑色陶瓦",
  "block.minecraft.barrier": "障幕",
  "block.minecraft.iron_trapdoor": "鐵製地板門",
  "block.minecraft.hay_block": "乾草捆",
  "block.minecraft.white_carpet": "白色地氈",
  "block.minecraft.orange_carpet": "橙色地氈",
  "block.minecraft.magenta_carpet": "紫紅色地氈",
  "block.minecraft.light_blue_carpet": "淺藍色地氈",
  "block.minecraft.yellow_carpet": "黃色地氈",
  "block.minecraft.lime_carpet": "淺綠色地氈",
  "block.minecraft.pink_carpet": "粉紅色地氈",
  "block.minecraft.gray_carpet": "灰色地氈",
  "block.minecraft.light_gray_carpet": "淺灰色地氈",
  "block.minecraft.cyan_carpet": "青藍色地氈",
  "block.minecraft.purple_carpet": "紫色地氈",
  "block.minecraft.blue_carpet": "藍色地氈",
  "block.minecraft.brown_carpet": "啡色地氈",
  "block.minecraft.green_carpet": "綠色地氈",
  "block.minecraft.red_carpet": "紅色地氈",
  "block.minecraft.black_carpet": "黑色地氈",
  "block.minecraft.terracotta": "陶瓦",
  "block.minecraft.coal_block": "煤炭磚",
  "block.minecraft.packed_ice": "冰磚",
  "block.minecraft.acacia_stairs": "相思木樓梯",
  "block.minecraft.dark_oak_stairs": "黑橡木樓梯",
  "block.minecraft.slime_block": "史萊姆方塊",
  "block.minecraft.grass_path": "草徑",
  "block.minecraft.sunflower": "向日葵",
  "block.minecraft.lilac": "紫丁香",
  "block.minecraft.rose_bush": "玫瑰叢",
  "block.minecraft.peony": "牡丹花",
  "block.minecraft.tall_grass": "長草叢",
  "block.minecraft.large_fern": "大型蕨",
  "block.minecraft.white_stained_glass": "白色染色玻璃",
  "block.minecraft.orange_stained_glass": "橙色染色玻璃",
  "block.minecraft.magenta_stained_glass": "紫紅色染色玻璃",
  "block.minecraft.light_blue_stained_glass": "淺藍色染色玻璃",
  "block.minecraft.yellow_stained_glass": "黃色染色玻璃",
  "block.minecraft.lime_stained_glass": "淺綠色染色玻璃",
  "block.minecraft.pink_stained_glass": "粉紅色染色玻璃",
  "block.minecraft.gray_stained_glass": "灰色染色玻璃",
  "block.minecraft.light_gray_stained_glass": "淺灰色染色玻璃",
  "block.minecraft.cyan_stained_glass": "青藍色染色玻璃",
  "block.minecraft.purple_stained_glass": "紫色染色玻璃",
  "block.minecraft.blue_stained_glass": "藍色染色玻璃",
  "block.minecraft.brown_stained_glass": "啡色染色玻璃",
  "block.minecraft.green_stained_glass": "綠色染色玻璃",
  "block.minecraft.red_stained_glass": "紅色染色玻璃",
  "block.minecraft.black_stained_glass": "黑色染色玻璃",
  "block.minecraft.white_stained_glass_pane": "白色染色玻璃片",
  "block.minecraft.orange_stained_glass_pane": "橙色染色玻璃片",
  "block.minecraft.magenta_stained_glass_pane": "紫紅色染色玻璃片",
  "block.minecraft.light_blue_stained_glass_pane": "淺藍色染色玻璃片",
  "block.minecraft.yellow_stained_glass_pane": "黃色染色玻璃片",
  "block.minecraft.lime_stained_glass_pane": "淺綠色染色玻璃片",
  "block.minecraft.pink_stained_glass_pane": "粉紅色染色玻璃片",
  "block.minecraft.gray_stained_glass_pane": "灰色染色玻璃片",
  "block.minecraft.light_gray_stained_glass_pane": "淺灰色染色玻璃片",
  "block.minecraft.cyan_stained_glass_pane": "青藍色染色玻璃片",
  "block.minecraft.purple_stained_glass_pane": "紫色染色玻璃片",
  "block.minecraft.blue_stained_glass_pane": "藍色染色玻璃片",
  "block.minecraft.brown_stained_glass_pane": "啡色染色玻璃片",
  "block.minecraft.green_stained_glass_pane": "綠色染色玻璃片",
  "block.minecraft.red_stained_glass_pane": "紅色染色玻璃片",
  "block.minecraft.black_stained_glass_pane": "黑色染色玻璃片",
  "block.minecraft.prismarine": "海磷石",
  "block.minecraft.prismarine_bricks": "海磷石磚",
  "block.minecraft.dark_prismarine": "暗海磷石",
  "block.minecraft.prismarine_stairs": "海磷石樓梯",
  "block.minecraft.prismarine_brick_stairs": "海磷石磚樓梯",
  "block.minecraft.dark_prismarine_stairs": "暗海磷石樓梯",
  "block.minecraft.sea_lantern": "海燈籠",
  "block.minecraft.red_sandstone": "紅砂岩",
  "block.minecraft.chiseled_red_sandstone": "浮雕紅砂岩",
  "block.minecraft.cut_red_sandstone": "切製紅砂岩",
  "block.minecraft.red_sandstone_stairs": "紅砂岩樓梯",
  "block.minecraft.repeating_command_block": "重複型命令方塊",
  "block.minecraft.chain_command_block": "連環型命令方塊",
  "block.minecraft.magma_block": "岩漿塊",
  "block.minecraft.nether_wart_block": "地獄孢子塊",
  "block.minecraft.warped_wart_block": "迷離孢子塊",
  "block.minecraft.red_nether_bricks": "紅色地獄磚",
  "block.minecraft.bone_block": "骨塊",
  "block.minecraft.structure_void": "結構空位",
  "block.minecraft.observer": "偵測器",
  "block.minecraft.shulker_box": "界伏盒",
  "block.minecraft.white_shulker_box": "白色界伏盒",
  "block.minecraft.orange_shulker_box": "橙色界伏盒",
  "block.minecraft.magenta_shulker_box": "紫紅色界伏盒",
  "block.minecraft.light_blue_shulker_box": "淺藍色界伏盒",
  "block.minecraft.yellow_shulker_box": "黃色界伏盒",
  "block.minecraft.lime_shulker_box": "淺綠色界伏盒",
  "block.minecraft.pink_shulker_box": "粉紅色界伏盒",
  "block.minecraft.gray_shulker_box": "灰色界伏盒",
  "block.minecraft.light_gray_shulker_box": "淺灰色界伏盒",
  "block.minecraft.cyan_shulker_box": "青藍色界伏盒",
  "block.minecraft.purple_shulker_box": "紫色界伏盒",
  "block.minecraft.blue_shulker_box": "藍色界伏盒",
  "block.minecraft.brown_shulker_box": "啡色界伏盒",
  "block.minecraft.green_shulker_box": "綠色界伏盒",
  "block.minecraft.red_shulker_box": "紅色界伏盒",
  "block.minecraft.black_shulker_box": "黑色界伏盒",
  "block.minecraft.white_glazed_terracotta": "白色釉陶",
  "block.minecraft.orange_glazed_terracotta": "橙色釉陶",
  "block.minecraft.magenta_glazed_terracotta": "紫紅色釉陶",
  "block.minecraft.light_blue_glazed_terracotta": "淺藍色釉陶",
  "block.minecraft.yellow_glazed_terracotta": "黃色釉陶",
  "block.minecraft.lime_glazed_terracotta": "淺綠色釉陶",
  "block.minecraft.pink_glazed_terracotta": "粉紅色釉陶",
  "block.minecraft.gray_glazed_terracotta": "灰色釉陶",
  "block.minecraft.light_gray_glazed_terracotta": "淺灰色釉陶",
  "block.minecraft.cyan_glazed_terracotta": "青藍色釉陶",
  "block.minecraft.purple_glazed_terracotta": "紫色釉陶",
  "block.minecraft.blue_glazed_terracotta": "藍色釉陶",
  "block.minecraft.brown_glazed_terracotta": "啡色釉陶",
  "block.minecraft.green_glazed_terracotta": "綠色釉陶",
  "block.minecraft.red_glazed_terracotta": "紅色釉陶",
  "block.minecraft.black_glazed_terracotta": "黑色釉陶",
  "block.minecraft.white_concrete": "白色混凝土",
  "block.minecraft.orange_concrete": "橙色混凝土",
  "block.minecraft.magenta_concrete": "紫紅色混凝土",
  "block.minecraft.light_blue_concrete": "淺藍色混凝土",
  "block.minecraft.yellow_concrete": "黃色混凝土",
  "block.minecraft.lime_concrete": "淺綠色混凝土",
  "block.minecraft.pink_concrete": "粉紅色混凝土",
  "block.minecraft.gray_concrete": "灰色混凝土",
  "block.minecraft.light_gray_concrete": "淺灰色混凝土",
  "block.minecraft.cyan_concrete": "青藍色混凝土",
  "block.minecraft.purple_concrete": "紫色混凝土",
  "block.minecraft.blue_concrete": "藍色混凝土",
  "block.minecraft.brown_concrete": "啡色混凝土",
  "block.minecraft.green_concrete": "綠色混凝土",
  "block.minecraft.red_concrete": "紅色混凝土",
  "block.minecraft.black_concrete": "黑色混凝土",
  "block.minecraft.white_concrete_powder": "白色混凝土粉末",
  "block.minecraft.orange_concrete_powder": "橙色混凝土粉末",
  "block.minecraft.magenta_concrete_powder": "紫紅色混凝土粉末",
  "block.minecraft.light_blue_concrete_powder": "淺藍色混凝土粉末",
  "block.minecraft.yellow_concrete_powder": "黃色混凝土粉末",
  "block.minecraft.lime_concrete_powder": "淺綠色混凝土粉末",
  "block.minecraft.pink_concrete_powder": "粉紅色混凝土粉末",
  "block.minecraft.gray_concrete_powder": "灰色混凝土粉末",
  "block.minecraft.light_gray_concrete_powder": "淺灰色混凝土粉末",
  "block.minecraft.cyan_concrete_powder": "青藍色混凝土粉末",
  "block.minecraft.purple_concrete_powder": "紫色混凝土粉末",
  "block.minecraft.blue_concrete_powder": "藍色混凝土粉末",
  "block.minecraft.brown_concrete_powder": "啡色混凝土粉末",
  "block.minecraft.green_concrete_powder": "綠色混凝土粉末",
  "block.minecraft.red_concrete_powder": "紅色混凝土粉末",
  "block.minecraft.black_concrete_powder": "黑色混凝土粉末",
  "block.minecraft.turtle_egg": "海龜蛋",
  "block.minecraft.dead_tube_coral_block": "死亡管珊瑚方塊",
  "block.minecraft.dead_brain_coral_block": "死亡腦珊瑚方塊",
  "block.minecraft.dead_bubble_coral_block": "死亡氣泡珊瑚方塊",
  "block.minecraft.dead_fire_coral_block": "死亡火珊瑚方塊",
  "block.minecraft.dead_horn_coral_block": "死亡角珊瑚方塊",
  "block.minecraft.tube_coral_block": "管珊瑚方塊",
  "block.minecraft.brain_coral_block": "腦珊瑚方塊",
  "block.minecraft.bubble_coral_block": "氣泡珊瑚方塊",
  "block.minecraft.fire_coral_block": "火珊瑚方塊",
  "block.minecraft.horn_coral_block": "角珊瑚方塊",
  "block.minecraft.tube_coral": "管珊瑚",
  "block.minecraft.brain_coral": "腦珊瑚",
  "block.minecraft.bubble_coral": "氣泡珊瑚",
  "block.minecraft.fire_coral": "火珊瑚",
  "block.minecraft.horn_coral": "角珊瑚",
  "block.minecraft.dead_brain_coral": "死亡腦珊瑚",
  "block.minecraft.dead_bubble_coral": "死亡氣泡珊瑚",
  "block.minecraft.dead_fire_coral": "死亡火珊瑚",
  "block.minecraft.dead_horn_coral": "死亡角珊瑚",
  "block.minecraft.dead_tube_coral": "死亡管珊瑚",
  "block.minecraft.tube_coral_fan": "扇狀管珊瑚",
  "block.minecraft.brain_coral_fan": "扇狀腦珊瑚",
  "block.minecraft.bubble_coral_fan": "扇狀氣泡珊瑚",
  "block.minecraft.fire_coral_fan": "扇狀火珊瑚",
  "block.minecraft.horn_coral_fan": "扇狀角珊瑚",
  "block.minecraft.dead_tube_coral_fan": "死亡扇狀管珊瑚",
  "block.minecraft.dead_brain_coral_fan": "死亡扇狀腦珊瑚",
  "block.minecraft.dead_bubble_coral_fan": "死亡扇狀氣泡珊瑚",
  "block.minecraft.dead_fire_coral_fan": "死亡扇狀火珊瑚",
  "block.minecraft.dead_horn_coral_fan": "死亡扇狀角珊瑚",
  "block.minecraft.blue_ice": "藍冰",
  "block.minecraft.conduit": "海靈核心",
  "block.minecraft.polished_granite_stairs": "拋光花崗岩樓梯",
  "block.minecraft.smooth_red_sandstone_stairs": "平滑紅砂岩樓梯",
  "block.minecraft.mossy_stone_brick_stairs": "青苔石磚樓梯",
  "block.minecraft.polished_diorite_stairs": "拋光閃長岩樓梯",
  "block.minecraft.mossy_cobblestone_stairs": "青苔碎石樓梯",
  "block.minecraft.end_stone_brick_stairs": "終界石磚樓梯",
  "block.minecraft.stone_stairs": "石頭樓梯",
  "block.minecraft.smooth_sandstone_stairs": "平滑砂岩樓梯",
  "block.minecraft.smooth_quartz_stairs": "平滑石英樓梯",
  "block.minecraft.granite_stairs": "花崗岩樓梯",
  "block.minecraft.andesite_stairs": "安山岩樓梯",
  "block.minecraft.red_nether_brick_stairs": "紅色地獄磚樓梯",
  "block.minecraft.polished_andesite_stairs": "拋光安山岩樓梯",
  "block.minecraft.diorite_stairs": "閃長岩樓梯",
  "block.minecraft.polished_granite_slab": "拋光花崗岩半磚",
  "block.minecraft.smooth_red_sandstone_slab": "平滑紅砂岩半磚",
  "block.minecraft.mossy_stone_brick_slab": "青苔石磚半磚",
  "block.minecraft.polished_diorite_slab": "拋光閃長岩半磚",
  "block.minecraft.mossy_cobblestone_slab": "青苔碎石半磚",
  "block.minecraft.end_stone_brick_slab": "終界石磚半磚",
  "block.minecraft.smooth_sandstone_slab": "平滑砂岩半磚",
  "block.minecraft.smooth_quartz_slab": "平滑石英半磚",
  "block.minecraft.granite_slab": "花崗岩半磚",
  "block.minecraft.andesite_slab": "安山岩半磚",
  "block.minecraft.red_nether_brick_slab": "紅色地獄磚半磚",
  "block.minecraft.polished_andesite_slab": "拋光安山岩半磚",
  "block.minecraft.diorite_slab": "閃長岩半磚",
  "block.minecraft.scaffolding": "竹棚",
  "block.minecraft.iron_door": "鐵門",
  "block.minecraft.oak_door": "橡木門",
  "block.minecraft.spruce_door": "杉木門",
  "block.minecraft.birch_door": "樺木門",
  "block.minecraft.jungle_door": "叢林木門",
  "block.minecraft.acacia_door": "相思木門",
  "block.minecraft.dark_oak_door": "黑橡木門",
  "block.minecraft.crimson_door": "猩紅菌木門",
  "block.minecraft.warped_door": "迷離菌木門",
  "block.minecraft.repeater": "紅石中繼器",
  "block.minecraft.comparator": "紅石比較器",
  "block.minecraft.structure_block": "結構方塊",
  "block.minecraft.jigsaw": "拼圖方塊",
  "item.minecraft.turtle_helmet": "海龜殼□□裝備於頭部時：□+2 盔甲",
  "item.minecraft.scute": "鱗甲",
  "item.minecraft.iron_shovel": "鐵鏟□□喺慣用手時：□+3.5 攻擊傷害□-3 攻擊速度",
  "item.minecraft.iron_pickaxe": "鐵鎬□□喺慣用手時：□+3 攻擊傷害□-2.8 攻擊速度",
  "item.minecraft.iron_axe": "鐵斧頭□□喺慣用手時：□+8 攻擊傷害□-3.1 攻擊速度",
  "item.minecraft.flint_and_steel": "打火石",
  "item.minecraft.apple": "蘋果",
  "item.minecraft.bow": "弓",
  "item.minecraft.arrow": "箭",
  "item.minecraft.coal": "煤炭",
  "item.minecraft.charcoal": "木炭",
  "item.minecraft.diamond": "鑽石",
  "item.minecraft.iron_ingot": "鐵錠",
  "item.minecraft.gold_ingot": "金錠",
  "item.minecraft.netherite_ingot": "地獄合金錠",
  "item.minecraft.netherite_scrap": "地獄合金碎片",
  "item.minecraft.iron_sword": "鐵劍□□喺慣用手時：□+5 攻擊傷害□-2.4 攻擊速度",
  "item.minecraft.wooden_sword": "木劍□□喺慣用手時：□+3 攻擊傷害□-2.4 攻擊速度",
  "item.minecraft.wooden_shovel": "木鏟□□喺慣用手時：□+1.5 攻擊傷害□-3 攻擊速度",
  "item.minecraft.wooden_pickaxe": "木鎬□□喺慣用手時：□+1 攻擊傷害□-2.8 攻擊速度",
  "item.minecraft.wooden_axe": "木斧頭□□喺慣用手時：□+6 攻擊傷害□-3.2 攻擊速度",
  "item.minecraft.stone_sword": "石劍□□喺慣用手時：□+4 攻擊傷害□-2.4 攻擊速度",
  "item.minecraft.stone_shovel": "石鏟□□喺慣用手時：□+2.5 攻擊傷害□-3 攻擊速度",
  "item.minecraft.stone_pickaxe": "石鎬□□喺慣用手時：□+2 攻擊傷害□-2.8 攻擊速度",
  "item.minecraft.stone_axe": "石斧頭□□喺慣用手時：□+8 攻擊傷害□-3.2 攻擊速度",
  "item.minecraft.diamond_sword": "鑽石劍□□喺慣用手時：□+6 攻擊傷害□-2.4 攻擊速度",
  "item.minecraft.diamond_shovel": "鑽石鏟□□喺慣用手時：□+4.5 攻擊傷害□-3 攻擊速度",
  "item.minecraft.diamond_pickaxe": "鑽石鎬□□喺慣用手時：□+4 攻擊傷害□-2.8 攻擊速度",
  "item.minecraft.diamond_axe": "鑽石斧頭□□喺慣用手時：□+8 攻擊傷害□-3 攻擊速度",
  "item.minecraft.stick": "木棍",
  "item.minecraft.bowl": "碗",
  "item.minecraft.mushroom_stew": "蘑菇湯",
  "item.minecraft.golden_sword": "金劍□□喺慣用手時：□+3 攻擊傷害□-2.4 攻擊速度",
  "item.minecraft.golden_shovel": "金鏟□□喺慣用手時：□+1.5 攻擊傷害□-3 攻擊速度",
  "item.minecraft.golden_pickaxe": "金鎬□□喺慣用手時：□+1 攻擊傷害□-2.8 攻擊速度",
  "item.minecraft.golden_axe": "金斧頭□□喺慣用手時：□+6 攻擊傷害□-3 攻擊速度",
  "item.minecraft.netherite_sword": "地獄合金劍□□喺慣用手時：□+7 攻擊傷害□-2.4 攻擊速度",
  "item.minecraft.netherite_shovel": "地獄合金鏟□□喺慣用手時：□+5.5 攻擊傷害□-3 攻擊速度",
  "item.minecraft.netherite_pickaxe": "地獄合金鎬□□喺慣用手時：□+5 攻擊傷害□-2.8 攻擊速度",
  "item.minecraft.netherite_axe": "地獄合金斧頭□□喺慣用手時：□+9 攻擊傷害□-3 攻擊速度",
  "item.minecraft.string": "線",
  "item.minecraft.feather": "羽毛",
  "item.minecraft.gunpowder": "火藥",
  "item.minecraft.wooden_hoe": "木鋤頭□□喺慣用手時：□-3 攻擊速度",
  "item.minecraft.stone_hoe": "石鋤頭□□喺慣用手時：□-2 攻擊速度",
  "item.minecraft.iron_hoe": "鐵鋤頭□□喺慣用手時：□-1 攻擊速度",
  "item.minecraft.diamond_hoe": "鑽石鋤頭□□喺慣用手時：",
  "item.minecraft.golden_hoe": "金鋤頭□□喺慣用手時：□-3 攻擊速度",
  "item.minecraft.netherite_hoe": "地獄合金鋤頭□□喺慣用手時：",
  "item.minecraft.wheat_seeds": "小麥種子",
  "item.minecraft.wheat": "小麥",
  "item.minecraft.bread": "麪包",
  "item.minecraft.leather_helmet": "皮革帽□□裝備於頭部時：□+1 盔甲",
  "item.minecraft.leather_chestplate": "皮革衫□□裝備於身上時：□+3 盔甲",
  "item.minecraft.leather_leggings": "皮革褲□□裝備於腿部時：□+2 盔甲",
  "item.minecraft.leather_boots": "皮革靴□□裝備於腳上時：□+1 盔甲",
  "item.minecraft.chainmail_helmet": "鎖鏈頭盔□□裝備於頭部時：□+2 盔甲",
  "item.minecraft.chainmail_chestplate": "鎖鏈胸甲□□裝備於身上時：□+5 盔甲",
  "item.minecraft.chainmail_leggings": "鎖鏈護腳□□裝備於腿部時：□+4 盔甲",
  "item.minecraft.chainmail_boots": "鎖鏈靴□□裝備於腳上時：□+1 盔甲",
  "item.minecraft.iron_helmet": "鐵頭盔□□裝備於頭部時：□+2 盔甲",
  "item.minecraft.iron_chestplate": "鐵胸甲□□裝備於身上時：□+6 盔甲",
  "item.minecraft.iron_leggings": "鐵護腳□□裝備於腿部時：□+5 盔甲",
  "item.minecraft.iron_boots": "鐵靴□□裝備於腳上時：□+2 盔甲",
  "item.minecraft.diamond_helmet": "鑽石頭盔□□裝備於頭部時：□+3 盔甲□+2 盔甲強度",
  "item.minecraft.diamond_chestplate": "鑽石胸甲□□裝備於身上時：□+8 盔甲□+2 盔甲強度",
  "item.minecraft.diamond_leggings": "鑽石護腳□□裝備於腿部時：□+6 盔甲□+2 盔甲強度",
  "item.minecraft.diamond_boots": "鑽石靴□□裝備於腳上時：□+3 盔甲□+2 盔甲強度",
  "item.minecraft.golden_helmet": "金頭盔□□裝備於頭部時：□+2 盔甲",
  "item.minecraft.golden_chestplate": "金胸甲□□裝備於身上時：□+5 盔甲",
  "item.minecraft.golden_leggings": "金護腳□□裝備於腿部時：□+3 盔甲",
  "item.minecraft.golden_boots": "金靴□□裝備於腳上時：□+1 盔甲",
  "item.minecraft.netherite_helmet": "地獄合金頭盔□□裝備於頭部時：□+3 盔甲□+3 盔甲強度□+1 抗擊退",
  "item.minecraft.netherite_chestplate": "地獄合金胸甲□□裝備於身上時：□+8 盔甲□+3 盔甲強度□+1 抗擊退",
  "item.minecraft.netherite_leggings": "地獄合金護腳□□裝備於腿部時：□+6 盔甲□+3 盔甲強度□+1 抗擊退",
  "item.minecraft.netherite_boots": "地獄合金靴□□裝備於腳上時：□+3 盔甲□+3 盔甲強度□+1 抗擊退",
  "item.minecraft.flint": "燧石",
  "item.minecraft.porkchop": "生豬扒",
  "item.minecraft.cooked_porkchop": "熟豬扒",
  "item.minecraft.painting": "畫",
  "item.minecraft.golden_apple": "金蘋果",
  "item.minecraft.enchanted_golden_apple": "附魔金蘋果",
  "block.minecraft.oak_sign": "橡木指示牌",
  "block.minecraft.spruce_sign": "杉木指示牌",
  "block.minecraft.birch_sign": "樺木指示牌",
  "block.minecraft.jungle_sign": "叢林木指示牌",
  "block.minecraft.acacia_sign": "相思木指示牌",
  "block.minecraft.dark_oak_sign": "黑橡木指示牌",
  "block.minecraft.crimson_sign": "猩紅菌木指示牌",
  "block.minecraft.warped_sign": "迷離菌木指示牌",
  "item.minecraft.bucket": "鐵桶",
  "item.minecraft.water_bucket": "水桶",
  "item.minecraft.lava_bucket": "熔岩桶",
  "item.minecraft.minecart": "礦車",
  "item.minecraft.saddle": "鞍",
  "item.minecraft.redstone": "紅石粉",
  "item.minecraft.snowball": "雪球",
  "item.minecraft.oak_boat": "橡木船",
  "item.minecraft.leather": "皮革",
  "item.minecraft.milk_bucket": "鮮奶桶",
  "item.minecraft.pufferfish_bucket": "雞泡魚桶",
  "item.minecraft.salmon_bucket": "三文魚桶",
  "item.minecraft.cod_bucket": "鱈魚桶",
  "item.minecraft.tropical_fish_bucket": "熱帶魚桶",
  "item.minecraft.brick": "紅磚頭",
  "item.minecraft.clay_ball": "黏土球",
  "block.minecraft.dried_kelp_block": "乾海帶捆",
  "item.minecraft.paper": "紙",
  "item.minecraft.book": "書",
  "item.minecraft.slime_ball": "史萊姆球",
  "item.minecraft.chest_minecart": "儲物箱礦車",
  "item.minecraft.furnace_minecart": "熔爐礦車",
  "item.minecraft.egg": "雞蛋",
  "item.minecraft.compass": "指南針",
  "item.minecraft.fishing_rod": "魚竿",
  "item.minecraft.clock": "時鐘",
  "item.minecraft.glowstone_dust": "熒光石粉",
  "item.minecraft.cod": "生鱈魚",
  "item.minecraft.salmon": "生三文魚",
  "item.minecraft.tropical_fish": "熱帶魚",
  "item.minecraft.pufferfish": "雞泡魚",
  "item.minecraft.cooked_cod": "熟鱈魚",
  "item.minecraft.cooked_salmon": "熟三文魚",
  "item.minecraft.ink_sac": "墨囊",
  "item.minecraft.red_dye": "紅色染料",
  "item.minecraft.green_dye": "綠色染料",
  "item.minecraft.cocoa_beans": "可可豆",
  "item.minecraft.lapis_lazuli": "青金石",
  "item.minecraft.purple_dye": "紫色染料",
  "item.minecraft.cyan_dye": "青藍色染料",
  "item.minecraft.light_gray_dye": "淺灰色染料",
  "item.minecraft.gray_dye": "灰色染料",
  "item.minecraft.pink_dye": "粉紅色染料",
  "item.minecraft.lime_dye": "淺綠色染料",
  "item.minecraft.yellow_dye": "黃色染料",
  "item.minecraft.light_blue_dye": "淺藍色染料",
  "item.minecraft.magenta_dye": "紫紅色染料",
  "item.minecraft.orange_dye": "橙色染料",
  "item.minecraft.bone_meal": "骨粉",
  "item.minecraft.blue_dye": "藍色染料",
  "item.minecraft.brown_dye": "啡色染料",
  "item.minecraft.black_dye": "黑色染料",
  "item.minecraft.white_dye": "白色染料",
  "item.minecraft.bone": "骨頭",
  "item.minecraft.sugar": "糖",
  "block.minecraft.cake": "蛋糕",
  "block.minecraft.white_bed": "白色牀",
  "block.minecraft.orange_bed": "橙色牀",
  "block.minecraft.magenta_bed": "紫紅色牀",
  "block.minecraft.light_blue_bed": "淺藍色牀",
  "block.minecraft.yellow_bed": "黃色牀",
  "block.minecraft.lime_bed": "淺綠色牀",
  "block.minecraft.pink_bed": "粉紅色牀",
  "block.minecraft.gray_bed": "灰色牀",
  "block.minecraft.light_gray_bed": "淺灰色牀",
  "block.minecraft.cyan_bed": "青藍色牀",
  "block.minecraft.purple_bed": "紫色牀",
  "block.minecraft.blue_bed": "藍色牀",
  "block.minecraft.brown_bed": "啡色牀",
  "block.minecraft.green_bed": "綠色牀",
  "block.minecraft.red_bed": "紅色牀",
  "block.minecraft.black_bed": "黑色牀",
  "item.minecraft.cookie": "曲奇",
  "item.minecraft.filled_map": "地圖□#0",
  "item.minecraft.shears": "鉸剪",
  "item.minecraft.melon_slice": "西瓜片",
  "item.minecraft.dried_kelp": "乾海帶",
  "item.minecraft.pumpkin_seeds": "南瓜種子",
  "item.minecraft.melon_seeds": "西瓜種子",
  "item.minecraft.beef": "生牛肉",
  "item.minecraft.cooked_beef": "牛扒",
  "item.minecraft.chicken": "生雞肉",
  "item.minecraft.cooked_chicken": "熟雞肉",
  "item.minecraft.rotten_flesh": "腐肉",
  "item.minecraft.ender_pearl": "終界珍珠",
  "item.minecraft.blaze_rod": "烈焰棒",
  "item.minecraft.ghast_tear": "幽靈之淚",
  "item.minecraft.gold_nugget": "金粒",
  "item.minecraft.nether_wart": "地獄孢子",
  "item.minecraft.potion": "不可合成嘅藥水□無效果",
  "item.minecraft.glass_bottle": "玻璃樽",
  "item.minecraft.spider_eye": "蜘蛛眼",
  "item.minecraft.fermented_spider_eye": "發酵蜘蛛眼",
  "item.minecraft.blaze_powder": "烈焰粉",
  "item.minecraft.magma_cream": "岩漿球",
  "block.minecraft.brewing_stand": "釀造台",
  "block.minecraft.cauldron": "鍋",
  "item.minecraft.ender_eye": "終界之眼",
  "item.minecraft.glistering_melon_slice": "鑲金西瓜片",
  "item.minecraft.bat_spawn_egg": "蝙蝠 生成蛋",
  "item.minecraft.bee_spawn_egg": "蜜蜂 生成蛋",
  "item.minecraft.blaze_spawn_egg": "烈焰使者 生成蛋",
  "item.minecraft.cat_spawn_egg": "貓 生成蛋",
  "item.minecraft.cave_spider_spawn_egg": "洞穴蜘蛛 生成蛋",
  "item.minecraft.chicken_spawn_egg": "雞 生成蛋",
  "item.minecraft.cod_spawn_egg": "鱈魚 生成蛋",
  "item.minecraft.cow_spawn_egg": "牛 生成蛋",
  "item.minecraft.creeper_spawn_egg": "creeper 生成蛋",
  "item.minecraft.dolphin_spawn_egg": "海豚 生成蛋",
  "item.minecraft.donkey_spawn_egg": "驢 生成蛋",
  "item.minecraft.drowned_spawn_egg": "沉屍 生成蛋",
  "item.minecraft.elder_guardian_spawn_egg": "遠古深海守衞 生成蛋",
  "item.minecraft.enderman_spawn_egg": "終界使者 生成蛋",
  "item.minecraft.endermite_spawn_egg": "終界蟎 生成蛋",
  "item.minecraft.evoker_spawn_egg": "喚魔者 生成蛋",
  "item.minecraft.fox_spawn_egg": "狐狸 生成蛋",
  "item.minecraft.ghast_spawn_egg": "地獄幽靈 生成蛋",
  "item.minecraft.guardian_spawn_egg": "深海守衞 生成蛋",
  "item.minecraft.hoglin_spawn_egg": "野豬獸 生成蛋",
  "item.minecraft.horse_spawn_egg": "馬 生成蛋",
  "item.minecraft.husk_spawn_egg": "屍殼 生成蛋",
  "item.minecraft.llama_spawn_egg": "羊駝 生成蛋",
  "item.minecraft.magma_cube_spawn_egg": "岩漿史萊姆 生成蛋",
  "item.minecraft.mooshroom_spawn_egg": "蘑菇牛 生成蛋",
  "item.minecraft.mule_spawn_egg": "騾 生成蛋",
  "item.minecraft.ocelot_spawn_egg": "豹貓 生成蛋",
  "item.minecraft.panda_spawn_egg": "熊貓 生成蛋",
  "item.minecraft.parrot_spawn_egg": "鸚鵡 生成蛋",
  "item.minecraft.phantom_spawn_egg": "夜魅 生成蛋",
  "item.minecraft.pig_spawn_egg": "豬 生成蛋",
  "item.minecraft.piglin_spawn_egg": "豬人 生成蛋",
  "item.minecraft.pillager_spawn_egg": "掠奪者 生成蛋",
  "item.minecraft.polar_bear_spawn_egg": "北極熊 生成蛋",
  "item.minecraft.pufferfish_spawn_egg": "雞泡魚 生成蛋",
  "item.minecraft.rabbit_spawn_egg": "兔 生成蛋",
  "item.minecraft.ravager_spawn_egg": "劫毀獸 生成蛋",
  "item.minecraft.salmon_spawn_egg": "三文魚 生成蛋",
  "item.minecraft.sheep_spawn_egg": "綿羊 生成蛋",
  "item.minecraft.shulker_spawn_egg": "界伏蚌 生成蛋",
  "item.minecraft.silverfish_spawn_egg": "蠹魚 生成蛋",
  "item.minecraft.skeleton_spawn_egg": "骷髏骨 生成蛋",
  "item.minecraft.skeleton_horse_spawn_egg": "骷髏骨馬 生成蛋",
  "item.minecraft.slime_spawn_egg": "史萊姆 生成蛋",
  "item.minecraft.spider_spawn_egg": "蜘蛛 生成蛋",
  "item.minecraft.squid_spawn_egg": "墨魚 生成蛋",
  "item.minecraft.stray_spawn_egg": "流浪者 生成蛋",
  "item.minecraft.strider_spawn_egg": "熾足獸 生成蛋",
  "item.minecraft.trader_llama_spawn_egg": "商隊羊駝 生成蛋",
  "item.minecraft.tropical_fish_spawn_egg": "熱帶魚 生成蛋",
  "item.minecraft.turtle_spawn_egg": "海龜 生成蛋",
  "item.minecraft.vex_spawn_egg": "惱鬼 生成蛋",
  "item.minecraft.villager_spawn_egg": "村民 生成蛋",
  "item.minecraft.vindicator_spawn_egg": "衞道士 生成蛋",
  "item.minecraft.wandering_trader_spawn_egg": "流浪商人 生成蛋",
  "item.minecraft.witch_spawn_egg": "女巫 生成蛋",
  "item.minecraft.wither_skeleton_spawn_egg": "凋零骷髏骨 生成蛋",
  "item.minecraft.wolf_spawn_egg": "狼 生成蛋",
  "item.minecraft.zoglin_spawn_egg": "豬屍獸 生怪蛋",
  "item.minecraft.zombie_spawn_egg": "殭屍 生成蛋",
  "item.minecraft.zombie_horse_spawn_egg": "殭屍馬 生成蛋",
  "item.minecraft.zombie_villager_spawn_egg": "殭屍村民 生成蛋",
  "item.minecraft.zombified_piglin_spawn_egg": "殭屍豬人 生成蛋",
  "item.minecraft.experience_bottle": "附魔之瓶",
  "item.minecraft.fire_charge": "火焰彈",
  "item.minecraft.writable_book": "書同羽毛筆",
  "item.minecraft.written_book": "寫好嘅書",
  "item.minecraft.emerald": "綠寶石",
  "item.minecraft.item_frame": "物品展示框",
  "block.minecraft.flower_pot": "花盆",
  "item.minecraft.carrot": "紅蘿蔔",
  "item.minecraft.potato": "薯仔",
  "item.minecraft.baked_potato": "焗薯仔",
  "item.minecraft.poisonous_potato": "毒薯仔",
  "item.minecraft.map": "空白地圖",
  "item.minecraft.golden_carrot": "金紅蘿蔔",
  "block.minecraft.skeleton_skull": "骷髏骨頭",
  "block.minecraft.wither_skeleton_skull": "凋零骷髏骨頭",
  "block.minecraft.player_head": "玩家頭顱",
  "block.minecraft.zombie_head": "殭屍頭顱",
  "block.minecraft.creeper_head": "creeper 頭顱",
  "block.minecraft.dragon_head": "龍頭",
  "item.minecraft.carrot_on_a_stick": "紅蘿蔔魚竿",
  "item.minecraft.warped_fungus_on_a_stick": "迷離菌菇魚竿",
  "item.minecraft.nether_star": "地獄之星",
  "item.minecraft.pumpkin_pie": "南瓜批",
  "item.minecraft.firework_rocket": "煙花",
  "item.minecraft.firework_star": "煙花球",
  "item.minecraft.enchanted_book": "附魔書",
  "item.minecraft.nether_brick": "地獄磚頭",
  "item.minecraft.quartz": "地獄石英",
  "item.minecraft.tnt_minecart": "tnt 礦車",
  "item.minecraft.hopper_minecart": "漏斗礦車",
  "item.minecraft.prismarine_shard": "海磷碎片",
  "item.minecraft.prismarine_crystals": "海磷晶體",
  "item.minecraft.rabbit": "生兔肉",
  "item.minecraft.cooked_rabbit": "熟兔肉",
  "item.minecraft.rabbit_stew": "兔肉湯",
  "item.minecraft.rabbit_foot": "兔腳",
  "item.minecraft.rabbit_hide": "兔皮",
  "item.minecraft.armor_stand": "盔甲座",
  "item.minecraft.iron_horse_armor": "鐵馬甲",
  "item.minecraft.golden_horse_armor": "金馬甲",
  "item.minecraft.diamond_horse_armor": "鑽石馬甲",
  "item.minecraft.leather_horse_armor": "皮革馬甲",
  "item.minecraft.lead": "牽繩",
  "item.minecraft.name_tag": "命名牌",
  "item.minecraft.command_block_minecart": "命令方塊礦車",
  "item.minecraft.mutton": "生羊肉",
  "item.minecraft.cooked_mutton": "熟羊肉",
  "block.minecraft.white_banner": "白色橫額",
  "block.minecraft.orange_banner": "橙色橫額",
  "block.minecraft.magenta_banner": "紫紅色橫額",
  "block.minecraft.light_blue_banner": "淺藍色橫額",
  "block.minecraft.yellow_banner": "黃色橫額",
  "block.minecraft.lime_banner": "淺綠色橫額",
  "block.minecraft.pink_banner": "粉紅色橫額",
  "block.minecraft.gray_banner": "灰色橫額",
  "block.minecraft.light_gray_banner": "淺灰色橫額",
  "block.minecraft.cyan_banner": "青藍色橫額",
  "block.minecraft.purple_banner": "紫色橫額",
  "block.minecraft.blue_banner": "藍色橫額",
  "block.minecraft.brown_banner": "啡色橫額",
  "block.minecraft.green_banner": "綠色橫額",
  "block.minecraft.red_banner": "紅色橫額",
  "block.minecraft.black_banner": "黑色橫額",
  "item.minecraft.end_crystal": "終界水晶",
  "item.minecraft.chorus_fruit": "歌萊果",
  "item.minecraft.popped_chorus_fruit": "爆開嘅歌萊果",
  "item.minecraft.beetroot": "紅菜頭",
  "item.minecraft.beetroot_seeds": "紅菜頭種子",
  "item.minecraft.beetroot_soup": "紅菜頭湯",
  "item.minecraft.dragon_breath": "龍之吐息",
  "item.minecraft.splash_potion": "飛濺型不可合成嘅藥水□無效果",
  "item.minecraft.spectral_arrow": "追跡之箭",
  "item.minecraft.tipped_arrow": "不可合成嘅藥水箭□無效果",
  "item.minecraft.lingering_potion": "滯留型不可合成嘅藥水□無效果",
  "item.minecraft.shield": "盾牌",
  "item.minecraft.elytra": "鞘翅",
  "item.minecraft.spruce_boat": "杉木船",
  "item.minecraft.birch_boat": "樺木船",
  "item.minecraft.jungle_boat": "叢林木船",
  "item.minecraft.acacia_boat": "相思木船",
  "item.minecraft.dark_oak_boat": "黑橡木船",
  "item.minecraft.totem_of_undying": "不死圖騰",
  "item.minecraft.shulker_shell": "界伏殼",
  "item.minecraft.iron_nugget": "鐵粒",
  "item.minecraft.knowledge_book": "知識之書",
  "item.minecraft.debug_stick": "除錯棒",
  "item.minecraft.music_disc_13": "唱片□c418 - 13",
  "item.minecraft.music_disc_cat": "唱片□c418 - cat",
  "item.minecraft.music_disc_blocks": "唱片□c418 - blocks",
  "item.minecraft.music_disc_chirp": "唱片□c418 - chirp",
  "item.minecraft.music_disc_far": "唱片□c418 - far",
  "item.minecraft.music_disc_mall": "唱片□c418 - mall",
  "item.minecraft.music_disc_mellohi": "唱片□c418 - mellohi",
  "item.minecraft.music_disc_stal": "唱片□c418 - stal",
  "item.minecraft.music_disc_strad": "唱片□c418 - strad",
  "item.minecraft.music_disc_ward": "唱片□c418 - ward",
  "item.minecraft.music_disc_11": "唱片□c418 - 11",
  "item.minecraft.music_disc_wait": "唱片□c418 - wait",
  "item.minecraft.music_disc_pigstep": "唱片□lena raine - pigstep",
  "item.minecraft.trident": "三叉戟□□喺慣用手時：□+8 攻擊傷害□-2.9 攻擊速度",
  "item.minecraft.phantom_membrane": "夜魅膜",
  "item.minecraft.nautilus_shell": "鸚鵡螺殼",
  "item.minecraft.heart_of_the_sea": "海洋之心",
  "item.minecraft.crossbow": "弩",
  "item.minecraft.suspicious_stew": "可疑嘅燉湯",
  "block.minecraft.loom": "織布機",
  "item.minecraft.flower_banner_pattern": "橫額圖案□花朵圖案",
  "item.minecraft.creeper_banner_pattern": "橫額圖案□creeper 圖案",
  "item.minecraft.skull_banner_pattern": "橫額圖案□骷髏骨圖案",
  "item.minecraft.mojang_banner_pattern": "橫額圖案□mojang 標誌",
  "item.minecraft.globe_banner_pattern": "橫額圖案□地球",
  "item.minecraft.piglin_banner_pattern": "橫額圖案□豬鼻",
  "block.minecraft.composter": "堆肥桶",
  "block.minecraft.barrel": "木桶",
  "block.minecraft.smoker": "煙燻爐",
  "block.minecraft.blast_furnace": "高爐",
  "block.minecraft.cartography_table": "製圖台",
  "block.minecraft.fletching_table": "製箭台",
  "block.minecraft.grindstone": "砂輪",
  "block.minecraft.lectern": "講台",
  "block.minecraft.smithing_table": "鍛造台",
  "block.minecraft.stonecutter": "切石機",
  "block.minecraft.bell": "鐘",
  "block.minecraft.lantern": "燈籠",
  "block.minecraft.soul_lantern": "靈魂燈籠",
  "item.minecraft.sweet_berries": "甜莓",
  "block.minecraft.campfire": "營火",
  "block.minecraft.soul_campfire": "靈魂營火",
  "block.minecraft.shroomlight": "菌光體",
  "item.minecraft.honeycomb": "蜂巢蜜",
  "block.minecraft.bee_nest": "蜂巢",
  "block.minecraft.beehive": "蜂箱",
  "item.minecraft.honey_bottle": "蜜糖樽",
  "block.minecraft.honey_block": "蜜糖塊",
  "block.minecraft.honeycomb_block": "蜂巢蜜塊",
  "block.minecraft.lodestone": "磁石",
  "block.minecraft.netherite_block": "地獄合金磚",
  "block.minecraft.ancient_debris": "遠古殘骸",
  "block.minecraft.target": "標靶",
  "block.minecraft.crying_obsidian": "哭曜石",
  "block.minecraft.blackstone": "黑石",
  "block.minecraft.blackstone_slab": "黑石半磚",
  "block.minecraft.blackstone_stairs": "黑石樓梯",
  "block.minecraft.gilded_blackstone": "鑲金黑石",
  "block.minecraft.polished_blackstone": "拋光黑石",
  "block.minecraft.polished_blackstone_slab": "拋光黑石半磚",
  "block.minecraft.polished_blackstone_stairs": "拋光黑石樓梯",
  "block.minecraft.chiseled_polished_blackstone": "浮雕拋光黑石",
  "block.minecraft.polished_blackstone_bricks": "拋光黑石磚",
  "block.minecraft.polished_blackstone_brick_slab": "拋光黑石磚半磚",
  "block.minecraft.polished_blackstone_brick_stairs": "拋光黑石磚樓梯",
  "block.minecraft.cracked_polished_blackstone_bricks": "裂紋拋光黑石磚",
  "block.minecraft.respawn_anchor": "重生錨",
}
export const zh_hk = items; 
